import { algoliasearch } from "algoliasearch";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import "firebase/compat/analytics";
import { EAST4 } from "./utility/enums";
import { createNullCache } from '@algolia/cache-common'

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};


firebase.initializeApp(firebaseConfig);

const firestore = firebase.firestore();

const auth = firebase.auth();

const storage = firebase.storage();

const analytics = firebase.analytics();

analytics.logEvent('notification_received');

const fieldValue = firebase.firestore.FieldValue;

const emailAuthProvider = firebase.auth.EmailAuthProvider;

let httpUrl = process.env.REACT_APP_HTTP_URL;
let httpUrl_EAST4= process.env.REACT_APP_HTTP_URL_EAST4;
// let httpUrl_West3= "https://us-west3-project-everbary.cloudfunctions.net/";


let STRIPE_ID = process.env.REACT_APP_STRIPE_ID;

let PAYPAL_OPTIONS = {
                "client-id": 
                process.env.REACT_APP_PAYPAL_CLIENT_ID,
              }

const searchClientAlgolia = algoliasearch(process.env.REACT_APP_ALGOLIA_APP_ID, process.env.REACT_APP_ALGOLIA_API, {
  // Disable caching for completed requests
  responsesCache: createNullCache(),
  // Disable caching for in-flight requests
  requestsCache: createNullCache(),
});


// // eslint-disable-next-line no-restricted-globals
if (process.env.REACT_APP_ENV === "development") {
  console.log("localhost detected!");
  auth.useEmulator("http://127.0.0.1:9099");
  firestore.useEmulator("127.0.0.1", 8080);
  storage.useEmulator("127.0.0.1", 9199);
}

const checkFetchAlgoliaData = () => {
  if(process.env.REACT_APP_ENV === "development" || process.env.REACT_APP_ENV === "staging"){
    return false;
  }
  return true;
}

const getFullHttpUrl = (path, region) => {
  const fullUrl = region === EAST4 ? `${httpUrl_EAST4}${path}` : `${httpUrl}${path}`;
  return fullUrl;
}

const websiteUrl = process.env.REACT_APP_WEBSITE_URL || "https://www.everbary.com";


export { firestore, auth, storage, fieldValue, emailAuthProvider, getFullHttpUrl, STRIPE_ID, PAYPAL_OPTIONS, searchClientAlgolia, checkFetchAlgoliaData, websiteUrl };